// Hero banner JS

(function nerivioHeroBanner($, Drupal) {
  Drupal.behaviors.nerivioHeroBanner = {
    attach(context, settings) {
      /* Added below code for video autoplay functionality iOS. */
      var bgVideoContainers = document.querySelectorAll(".bg-video");
      bgVideoContainers.forEach(function (bgVideoContainer) {
        var videoElement = bgVideoContainer.querySelector("video");
        if (videoElement) {
          videoElement.setAttribute("playsinline", "");
          var section = $('.nerivio-hero-banner_description');
          videoElement.addEventListener('ended', function () {
            section.addClass('show-description');
          });
        }
      });
    },
  };
})(jQuery, Drupal);
